import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Characteristic, CharacteristicImage, MBTI } from 'src/app/interfaces/mbti';
import { baseColorCode } from 'src/utils/utils';

@Component({
  selector: 'ideal-type-mbti-description',
  templateUrl: './ideal-type-mbti-description.component.html',
  styleUrls: ['./ideal-type-mbti-description.component.scss']
})

export class IdealTypeQuizMbtiDescriptionComponent implements OnInit, OnChanges {

  @Input() mbti: MBTI | undefined;
  @Input() characteristic: Characteristic | undefined;
  @Input() favourTitle = '내 이상형이'
  @Input() favourIcon = 'comment-heart';
  @Input() mbtiImage?: string;
  @Input() showChangeButton: boolean = false;
  mbtiCharacteristic: CharacteristicImage | undefined

  get mbtiColor(): string {
    if (this.mbti) {
      return baseColorCode(this.mbti);
    }
    return ''
  }

  constructor() { }

  ngOnInit(): void {
    if (this.characteristic) {
      this.mbtiCharacteristic = { type: 'female', imageUrl: this.characteristic.femaleImageUrl }
    }
  }

  ngOnChanges(): void {
  }
  onClickChageImage() {
    if (!this.mbtiCharacteristic || !this.characteristic) return
    if (this.mbtiCharacteristic.type === 'female') {
      this.mbtiCharacteristic = { type: 'male', imageUrl: this.characteristic.maleImageUrl }
    } else {
      this.mbtiCharacteristic = { type: 'female', imageUrl: this.characteristic.femaleImageUrl }
    }
  }
}
